let dt = {
  headers: [
    {
      text: '№ Рейса',
      align: 'left',
      sortable: true,
      value: 'num'
    },
    {
      text: 'Отправление',
      value: 'time'
    },
    {
      text: 'Направление',
      value: 'to'
    },
    {
      text: 'Авиакомпания',
      value: 'ak'
    },
    {
      text: 'Стойки',
      value: 'reg'
    },
    {
      text: 'Посадка',
      value: 'out'
    },
    {
      text: 'Статус',
      value: 'status'
    }
  ],
  items: [
    {
      num: 12354,
      time: '12:51',
      to: 'DOM',
      ak: 'АК Россия',
      reg: 24,
      out: '14:21',
      status: true
    },
    {
      num: 12355,
      time: '12:51',
      to: 'ELF',
      ak: 'АК Россия',
      reg: 12,
      out: '14:21',
      status: false
    },
    {
      num: 12356,
      time: '13:56',
      to: 'RXV',
      ak: 'S7',
      reg: 62,
      out: '16:11',
      status: true
    },
    {
      num: 12357,
      time: '10:23',
      to: 'BHH',
      ak: 'АК Россия',
      reg: 34,
      out: '12:25',
      status: false
    },
    {
      num: 12358,
      time: '12:31',
      to: 'CSS',
      ak: 'АК Россия',
      reg: 24,
      out: '15:32',
      status: true
    }

  ]
}

export default dt
